import React, { Fragment } from "react";
import { createPortal } from 'react-dom';
import Panel from "../../../../components/Panel";
import { CPHY, PCIE } from "../../../../services/PCBHelper/constants";
import ReferenceLines from "../../../../components/ReferenceLine";
import { REFERENCE_LINE } from "../../../../constants/libraryConstants";
import { getReportGuideKeys, getReportGuideValue } from "../../../../services/helper/reportHelper";
import { getDefaultGuideValue } from "../../../../services/Andes_v2/results/sparameter/dataHelper";
import { Input, Select } from "antd";
import "./index.css";
import { checkNameFormat } from "../../../../services/helper/nameFormatCheck";
import libraryConstructor from "../../../../services/Andes_v2/library/libraryConstructor";
import { ANDES_INTERFACE_TYPES } from "../../../../services/Andes_v2/constants";

const defaultGuideKey = getReportGuideKeys('andes_v2_reference_line');
const defaultCPHYGuideKey = getReportGuideKeys('andes_v2_CPHY_reference_line');

const defaultCPHYSettingInfo = {
  symbolRate: 2.5,
  frequency: {
    fh: 1.25,
    fMax: 0.1875,
    fINTMin: 0.45,
    fLPMax: 0.01
  }
}
class ReferenceLinesPanel extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      tableData: [],
      name: "",
      editInputInfo: {},
      interfaceType: "PCIe",
      dataRate: 16,
      ...defaultCPHYSettingInfo
    }
    this.dialogRoot = document.getElementById('root');
    this.FileInfo = {};
    this.referenceLinesRef = null;
  }

  componentDidMount() {
    this.getJsonData();
  }

  componentDidUpdate(prevProps) {
    const { libraryId } = this.props;
    if (prevProps.libraryId !== libraryId) {
      this.getJsonData();
    }
  }

  getJsonData = () => {
    const { libraryId, defaultLibraryName, getLibraryDetail } = this.props;
    if (libraryId) {
      getLibraryDetail(libraryId).then(res => {
        if (res) {
          const { config } = res;
          this.FileInfo = JSON.parse(JSON.stringify(res));
          const interfaceType = res.tag;
          const guideValue = getDefaultGuideValue(interfaceType === CPHY ? "andes_v2_CPHY" : "andes_v2", null, config.guideValue);

          const { symbolRate, fh, fMax, fLPMax, fINTMin, dataRate } = config;
          this.setState({
            tableData: guideValue.map(item => ({ ...item })),
            name: res.name,
            interfaceType,
            ...(interfaceType === CPHY ? { symbolRate, fh, fMax, fLPMax, fINTMin }
              : interfaceType === PCIE ? { dataRate: dataRate || (guideValue[0] || {}).dataRate || 16 }
                : {})
          })
        }
      })
    } else {
      const guideValue = getReportGuideValue("andes_v2", defaultGuideKey, { interfaceType: PCIE });

      this.FileInfo = {
        name: defaultLibraryName,
        config: {
          guideValue
        }
      }
      this.setState({
        tableData: guideValue,
        name: defaultLibraryName,
        interfaceType: PCIE
      })
    }
  }

  closeModel = () => {
    const { tableData, error } = this.state;
    const { errorMsg } = this.referenceLinesRef.state;
    if (errorMsg && Object.keys(errorMsg)) {
      for (const key of Object.keys(errorMsg)) {
        if (errorMsg[key]) return;
      }
    }
    if (error) {
      return;
    }
    const { libraryId } = this.props;
    const { name, interfaceType, symbolRate, frequency, dataRate } = this.state;
    const { config } = this.FileInfo;
    const _defaultGuideKey = interfaceType === CPHY ? defaultCPHYGuideKey : defaultGuideKey
    const guideValue = (config.guideValue || []).map(item => {
      if (_defaultGuideKey.indexOf(item.name) !== -1) {
        return tableData[_defaultGuideKey.indexOf(item.name)]
      } else {
        return item
      }
    })
    let data = {
      name: name,
      id: libraryId,
      config: {
        ...config,
        guideValue: guideValue.map(item => {
          delete item.xDynamicRange;
          delete item.yDynamicRange;
          return item;
        }),
        ...(interfaceType === CPHY ? { ...frequency, symbolRate: Number(symbolRate) }
          : interfaceType === PCIE ? { dataRate: Number(dataRate) }
            : {})
      },
      type: REFERENCE_LINE,
      tag: interfaceType,
      version: "0.0.1",
    }

    // update library
    this.props._updateLibraryData(REFERENCE_LINE, data);
    this.props.closePanel()
  };

  changeTableData = (tableData) => {
    this.setState({ tableData });
  }

  changeEditInputInfo = (info) => {
    this.setState({ editInputInfo: { ...this.state.editInputInfo, ...info } });
  }

  saveName = () => {
    const { editInputInfo, name } = this.state;
    const { value, type } = editInputInfo;

    if (type === 'name') {
      let error = checkNameFormat(value);
      if (!error) {
        const { name: prevName } = this.props;
        const referenceLineList = libraryConstructor.getLibraryValues(REFERENCE_LINE);
        const libraryNames = referenceLineList.map(item => item.name);
        if (libraryNames.includes(name) && name !== prevName) {
          error = "The name already exists, please enter another name."
        }
      }
      this.setState({ name: value, editInputInfo: {}, error });
      return;
    }
  }

  changeSettingInfo = (settingInfo) => {
    this.setState({ ...settingInfo });
  }

  changeInterfaceType = (value) => {
    const key = value === CPHY ? 'andes_v2_CPHY' : 'andes_v2';
    const guideKey = value === CPHY ? defaultCPHYGuideKey : defaultGuideKey;
    const guideValue = getReportGuideValue(key, guideKey, { interfaceType: value });
    this.setState({
      interfaceType: value,
      tableData: guideValue,
      ...(value === CPHY ? defaultCPHYSettingInfo
        : value === PCIE ? { dataRate: 16 }
          : {})
    });
  }

  render() {
    const { tableData, editInputInfo, name, error, interfaceType, symbolRate, frequency, dataRate } = this.state;
    const { title, isEdit } = this.props;
    const { config = {} } = this.FileInfo;
    const content = (
      <Fragment>
        <Panel
          className='aurora-box-shadow'
          position='panel-center-left'
          title={title}
          width={interfaceType === CPHY ? 1200 : 800}
          onCancel={() => this.closeModel()}
          minWidth={700}
          draggable
          minHeight={500}
          zIndex={2000}
        >
          <div className="library-reference-line-content">
            <div className='library-reference-line-item'>
              <label className='library-reference-line-item-label'>Name</label>
              <Input
                disabled={!isEdit}
                value={editInputInfo.type === 'name' ? editInputInfo.value : name}
                className='aurora-input library-reference-line-item-value'
                onFocus={() => this.changeEditInputInfo({ type: 'name', value: name })}
                onChange={(e) => this.changeEditInputInfo({ value: e.target.value })}
                onBlur={() => this.saveName()}
              />
            </div>
            {error ? <div className='andes-v2-name-error-text'>{error}</div> : null}
            <div className='library-reference-line-item'>
              <label className='library-reference-line-item-label'>Type</label>
              <Select
                disabled={!isEdit}
                value={interfaceType}
                className='aurora-select library-reference-line-item-value'
                options={ANDES_INTERFACE_TYPES}
                onChange={(value) => this.changeInterfaceType(value)}
              />
            </div>
            <ReferenceLines
              ref={ref => this.referenceLinesRef = ref}
              type="Library"
              tableData={tableData}
              interfaceType={interfaceType}
              guideValue={config.guideValue || []}
              guideKey={interfaceType === CPHY ? defaultCPHYGuideKey : defaultGuideKey}
              dataRate={dataRate}
              symbolRate={symbolRate}
              frequency={frequency}
              changeTableData={this.changeTableData}
              changeConfig={(config) => this.setState({ config })}
              changeSettingInfo={this.changeSettingInfo}
              isEdit={isEdit}
            />
          </div>
        </Panel>
      </Fragment>
    )
    return createPortal(content, this.dialogRoot);
  }
}

export default ReferenceLinesPanel;